
declare var angular: angular.IAngularStatic;

// angular.module('specsguardApp', []);

import './app';

import './account/account.config';
import './account/activate/activate.controller';
import './account/auth.service';
import './account/logOut/logOut.controller';
import './account/login/login.controller';
import './account/settings/settings.controller';
import './app/app.config';
import './app/app.run';
import './app/authinterceptor.factory';
import './app/nocacheinterceptor.factory';
import './app/socket.service';
import './app/statusinterceptor.factory';
import './app/transitionnotifierinterceptor.factory';
import './app/update-notifier.factory';
import './area_template/areaTemplate.business.factory';
import './area_template/areaTemplate.config';
import './area_template/areaTemplate.controller';
import './area_template/areaTemplate.service';
import './area_template/edit-area-template/edit.area.template.controller';
import './building_template/buildingTemplate.config';
import './building_template/buildingTemplate.service';
import './components/mongoose-error/mongoose-error.directive';
import './components/services/datastructure.service';
import './components/services/session.service';
import './components/services/utils.service';
import './components/sg-password-strength/sg-password-strength.component';
import './components/sg-password-strength/sg-password-strength.controller';

import './components/sg-area-state-cluster-table/sg-area-state-cluster-table.component';
import './components/sg-area-state-cluster-table/sg-area-state-cluster-table.controller';
import './components/sg-attachments/sg-attachments-controller';
import './components/sg-attachments/sg-attachments-directive';
import './components/sg-autocomplete/sg-autocomplete-helpers';
import './components/sg-autocomplete/sgAutocomplete';
import './components/sg-drag-and-drop-lists/sg-drag-and-drop-lists.directive';
import './components/sg-element-activity/sg-element-activity.controller';
import './components/sg-element-activity/sg-element-activity.directive';
import './components/sg-element-activity/sg-element-activity.service';
import './components/sg-element-changelog/sg-element-changelog.component';
import './components/sg-element-counter/sg-element-counter.directive';
import './components/sg-element-dialog/sg-element-dialog.controller';
import './components/sg-element-dialog/sg-element-dialog.service';
import './components/sg-element-form/sg-element-form.controller';
import './components/sg-element-form/sg-element-form.directive';
import './components/sg-element-items/sg-element-comment-item';
import './components/sg-element-items/sg-element-created-item';
import './components/sg-element-items/sg-element-items.factory';
import './components/sg-element-items/sg-element-log-item';
import './components/sg-element-status/sg-element-status.component';
import './components/sg-element-status/sg-element-status.controller';
import './components/sg-expansion-panel/sg-expansion-panel-footer.controller';
import './components/sg-expansion-panel/sg-expansion-panel-footer.directive';
import './components/sg-expansion-panel/sg-expansion-panel.controller';
import './components/sg-expansion-panel/sg-expansion-panel.directive';
import './components/sg-expansion-panel/sg-expansion-panel.factory';
import './components/sg-form-with-info/sg-form-with-info.controller';
import './components/sg-form-with-info/sg-form-with-info.directive';
import './components/sg-gravatar-image/sg-gravatar-image.directive';
import './components/sg-help/sg-help.controller';
import './components/sg-help/sg-help.directive';
import './components/sg-hideable-sidenav/sg-hideable-sidenav.directive';
import './components/sg-html-attributes/sg-html-attributes.directive';
import './components/sg-inline-edit/sg-inline-edit.component';
import './components/sg-inline-edit/sg-inline-edit.controller';
import './components/sg-input/sg-input.directive';
import './components/sg-maps/sg-maps.directive';
import './components/sg-mat-table/sg-table-bulk-mode/sg-table-bulk-mode.directive';
import './components/sg-mat-table/sg-table-checkbox-filter/sg-table-checkbox-filter.directive';
import './components/sg-mat-table/sg-table-column-filter/sg-table-column-filter.directive';
import './components/sg-mat-table/sg-table-controller';
import './components/sg-mat-table/sg-table-date-filter/sg-table-date-filter.directive';
import './components/sg-mat-table/sg-table-header/sg-table-filter.controller';
import './components/sg-mat-table/sg-table-header/sg-table-filter.directive';
import './components/sg-mat-table/sg-table-radio-button-filter/sg-table-radio-button-filter.directive';
import './components/sg-mat-table/sg-table-text-filter/sg-table-text-filter.directive';
import './components/sg-mat-table/sg-table.directive';
import './components/sg-modules-treeview/sg-modules-treeview.controller';
import './components/sg-modules-treeview/sg-modules-treeview.directive';
import './components/sg-navigation/sg-navigation-label-replaces';
import './components/sg-navigation/sg-navigation.controller';
import './components/sg-navigation/sg-navigation.directive';
import './components/sg-option-list/sg-option-list.component';
import './components/sg-option-list/sg-option-list.controller';
import './components/sg-print-page/sg-print-page.controller';
import './components/sg-print-page/sg-print-page.directive';
import './components/sg-project-module/sg-project-module.directive';
import './components/sg-project-submodule/sg-project-submodule.directive';
import './components/sg-project-team/sg-project-team.controller';
import './components/sg-project-team/sg-project-team.directive';
import './components/sg-template-detail/sg-template-detail.controller';
import './components/sg-template-list/sg-template-list.controller';
import './components/sg-template-list/sg-template-list.directive';
import './components/sg-template-list/template_dialog/template_dialog.controller';
import './components/sg-transition-notifier/sg-transition-notifier.controller';
import './components/sg-transition-notifier/sg-transition-notifier.directive';
import './components/sg-upload/sg-upload-controller';
import './components/sg-upload/sg-upload-directive';
import './components/sg-upload/sg-upload-input-directive';
import './components/sg-upload/sg-upload-service';
import './components/sg-user-icon/sg-user-icon.controller';
import './components/sg-user-icon/sg-user-icon.directive';
import './components/showonhoverparent/showonhoverparent';
import './components/simple-dialog-form/simple.dialog.form.controller';
import './components/simple-dialog-form/simple.dialog.form.service';
import './constants/constants.service';
import './errors/errorMessageService';
import './filters/filters';
import './filters/sg-trusted';
import './filters/sg-date-ago';
import './filters/sg-date';
import './filters/sg-sanitize';
import './help/help.service';
import './labels/labels.service';
import './lib_element/LibElementTools.service';
import './lib_element/ModuleSubmoduleElements.service';
import './lib_element/libElement.config';
import './lib_element/libElement.controller';
import './lib_element/libElement.service';
import './menu/menu.service';
import './module/delete-module-dialog/delete_module_dialog.controller';
import './module/delete-submodule-dialog/delete_submodule_dialog.controller';
import './module/module.config';
import './module/module.controller';
import './module/module.service';
import './module/submodule-dialog/submodule_dialog.controller';
import './project/administration/project.administration.config';
import './project/administration/project.administration.controller';
import './project/administration/project.buildings.component';
import './project/administration/project.buildings.controller';
import './project/administration/project.location.component';
import './project/administration/project.location.controller';
import './project/administration/project.modules.component';
import './project/administration/project.modules.controller';
import './project/administration/project.settings.component';
import './project/administration/project.settings.controller';
import './project/areas/add-area/add.area.controller';
import './project/areas/add-cluster/add.cluster.controller';
import './project/areas/area-decorators.factory';
import './project/areas/areas.config';
import './project/areas/areas.controller';
import './project/areas/details-area/details-area.factory';
import './project/areas/details-area/details.area.controller';

// Matrix
import './project/areas/matrix/matrix.controller';
import './project/areas/matrix/matrix-element-value/matrix-element-value.component';
import './project/areas/matrix/matrix-element-value/matrix-element-value.controller';
import './project/areas/matrix/matrix-area-item/matrix-area-item.component';
import './project/areas/matrix/matrix-area-item/matrix-area-item.controller';


import './project/basic-areas/add-basic-area/add.basic.area.controller';
import './project/basic-areas/basic-area-logic.factory';
import './project/basic-areas/basic.areas.config';
import './project/basic-areas/basic.areas.controller';
import './project/building/buildingAdd/building.add.controller';
import './project/building/buildingAdd/buildingAddData.service';
import './project/documents/document-add/document-add.controller';
import './project/documents/documents.controller';
// import './project/elements/elements.controller';
import './project/elements/project-element-logs.interface';
import './project/elements/project-element.interface';
import './project/info/project.info.controller';
import './project/info/project.infoSelect.controller';
import './project/new/project.new.controller';
import './project/overview/project.overview.controller';
import './project/project.business.service';
import './project/project.config';
import './project/project.controller';
import './project/project.dataservice';
import './project/project.service';
import './project/project.state.manager.service';
import './project/project-module.interface';
import './project/project-submodule.interface';
import './project/project.interface';

import './project/filemanager/filemanager.controller';


// WIP: Better way of loading different widgets
import './components/sg-widget/sg-widget-container';
import './components/sg-widget/sg-widget-container.directive';
import './components/sg-widget/sg-widget/sg-widget.directive';
import './components/sg-widget/sg-widget/sg-widget.controller';
import './components/sg-widget/sg-widget-multiselect/sg-widget-multiselect.directive';

import './project/overview/widgets/areas/widget-project-areas.controller';
import './project/overview/widgets/areas/widget-project-areas.directive';

import './project/overview/widgets/assigned-elements/widget-project-assigned-elements.controller';
import './project/overview/widgets/assigned-elements/widget-project-assigned-elements.directive';

import './project/overview/widgets/documents/widget-project-documents.controller';
import './project/overview/widgets/documents/widget-project-documents.directive';

import './project/overview/widgets/log/widget-project-log.controller';
import './project/overview/widgets/log/widget-project-log.directive';

import './project/overview/widgets/comments/widget-project-comments.controller';
import './project/overview/widgets/comments/widget-project-comments.directive';

import './project/overview/widgets/overview/widget-project-overview.directive';

// Team widget
import './project/overview/widgets/team/widget-project-team.controller';
import './project/overview/widgets/team/widget-project-team.directive';
import './project/overview/widgets/team/add-user/widget-project-team-add-user.controller';

import './project/overview/widgets/info/widget-project-info.controller';
import './project/overview/widgets/info/widget-project-info.directive';



import './pve_template/pveTemplate.config';
import './pve_template/pveTemplate.service';
import './tech-element/details/tech.element.details.controller';
import './tech-element/modals/tech.element.module.service';
import './tech-element/modals/tech.element.submodule.service';
import './tech-element/tech.element.config';
import './tech-element/tech.element.controller';
import './tech-element/tech.element.service';
import './tenants/details/tenants.details.controller';
import './tenants/tenants-overview.controller';
import './tenants/tenants.config';
import './tenants/tenants.controller';
import './tenants/tenants.service';
import './text-editor/text-editor-config.factory';
import './user/details/user.details.controller';
import './user/user.config';
import './user/user.controller';
import './user/user.service';

import './account/user.interface';
import './area_template/area-template.interface';
import './building_template/building-template.interface';
import './project/areas/area.interface';
import './project/basic-areas/basic-area.interface';
import './project/building/building.interface';
import './project/building/building-cluster.interface';
import './project/documents/document.interface';
import './project/documents/document-file.interface';
import './project/elements/project-element-logs.interface';
import './pve_template/pve-template-log.interface';
import './pve_template/pve-template.interface';

import './app.shared';

import './app.downgrades';
export class AppLegacy {
  constructor() {

  }
}
